import React, {useState} from 'react'
import BrowserLink from '../../../../components/BrowserLink';
import CloseSvg from "../Svg/CloseSvg";
import * as cl from './GettingStarted.module.scss'


const GettingStarted = ({banner}) => {
  const [isShow, setIsShow] = useState(true)

  if (!isShow || banner === false) return null;

  const close = () => {
    setIsShow(false)
  }
  
  return (
    <article className={cl.wrapper}>
      <button className={cl.close} onClick={() => close()}>
        <CloseSvg/>
      </button>

      <div className={cl.info}>
        <h2 className={cl.info__title}>{banner.title}</h2>
        <p className={cl.info__content} dangerouslySetInnerHTML={{__html: banner.content}} />
        <BrowserLink href={banner.button.url} className={cl.info__button}>{banner.button.label}</BrowserLink>
      </div>

      {
        banner.products && banner.products.map((item, index) => (
          <BrowserLink href={item.url} className={cl.link} key={index}>
            <img src={item.img} alt={`product  №${index + 1}`} className={cl.link__img}/>
          </BrowserLink>
        ))
      }
    </article>
  )
}

export default GettingStarted
